import http from "../http-common";

const getAll = loc => {
    return http.get(`/v1/devicegroups/loc/${loc}`);
};

const getAllAdmin = () => {
    return http.get(`/v1/devicegroups`);
};

const get = id => {
    return http.get(`/v1/devicegroups/${id}`);
};

const create = data => {
    return http.post("/v1/devicegroups", data);
};

const update = (id, data) => {
    return http.put(`/v1/devicegroups/${id}`, data);
};

const remove = id => {
    return http.delete(`/v1/devicegroups/${id}`);
};

const removeAll = () => {
    return http.delete(`/v1/devicegroups`);
};

const findByName = name => {
    return http.get(`/v1/devicegroups?name=${name}`);
};

const getDevicesOnGroup = (groupId) => {
    return http.get(`/v1/devicegroups/group/${groupId}/devices`);
};

const bulkAssign = (data) => {
    return http.post("/v1/devicegroups/bulk-assign", data);
};

const bulkRemove = (groupId, deviceIds) => {
    return http.delete(`/v1/devicegroups/bulk-remove/${groupId}`, {
        data: { deviceIds },
    });
};

export default {
    getAll,
    getAllAdmin,
    get,
    create,
    update,
    remove,
    removeAll,
    findByName,
    getDevicesOnGroup,
    bulkAssign,
    bulkRemove,
};